import $ from 'jquery';

export const faqDidMount = () => {
    let hash = window.location.hash;
    if(hash) {
        var anchor = $('[href="'+ hash +'"]');
        var target = anchor.attr('href');
        var position = $(target).position();
        $('html, body').animate({
            scrollTop: position.top - 75
        }, 1000);
        var expand = $(`${target} div h3 div`);
        expand.click();
    }

    $('.list-policy-sidenav li a').on('click', function(e){
        var anchor = $(this);
        var target = anchor.attr('href');
        var position = $(target).position();
        $('html, body').animate({
            scrollTop: position.top - 75
        }, 1000);
        var expand = $(`${target} div h3 div`);
        expand.click();
        e.preventDefault();
    });

    $('.click-scroll').on('click', function(e){
        var anchor = $(this);
        var target = anchor.attr('href');
        var position = $(target).position();
        $('html, body').animate({
            scrollTop: position.top - 75
        }, 1000);
        var expand = $(`${target} div h3 div`);
        expand.click();
        e.preventDefault();
    });

    $(".expand").click(function() {
        // $(this).next().slideToggle(200);
        var expand = $(this).find(">:first-child");

        if(expand.text() === "+") {
            expand.text("-");
        } else {
            expand.text("+");
        }
    });
};



// WEBPACK FOOTER //
// ./src/helper/index.js